var _defs, _g, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgC6(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1080,
    zoomAndPan: "magnify",
    viewBox: "0 0 810 817.92",
    height: 1080,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "7920f19760"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 77.910156 77.867188 L 734.09375 77.867188 L 734.09375 734.054688 L 77.910156 734.054688 Z M 77.910156 77.867188 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7920f19760)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E53535",
    d: "M 406 77.867188 C 225.058594 77.867188 77.910156 225.019531 77.910156 405.960938 C 77.910156 586.902344 225.058594 734.054688 406 734.054688 C 586.941406 734.054688 734.09375 586.902344 734.09375 405.960938 C 734.09375 225.019531 586.941406 77.867188 406 77.867188 Z M 406 711.039062 C 237.546875 711.039062 100.921875 574.414062 100.921875 405.960938 C 100.921875 237.507812 237.546875 100.882812 406 100.882812 C 574.453125 100.882812 711.078125 237.507812 711.078125 405.960938 C 711.078125 574.414062 574.453125 711.039062 406 711.039062 Z M 406 711.039062 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E53535",
    d: "M 571.191406 300.269531 L 460.113281 405.960938 L 571.191406 511.652344 C 574.167969 507.589844 576.070312 503.074219 576.902344 498.105469 L 576.902344 313.816406 C 576.070312 308.851562 574.167969 304.335938 571.191406 300.269531 Z M 571.191406 300.269531 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E53535",
    d: "M 406 457.460938 L 360.296875 413.960938 L 249.300781 519.570312 C 251.855469 521.253906 254.601562 522.53125 257.53125 523.410156 C 260.464844 524.285156 263.460938 524.71875 266.519531 524.710938 L 545.480469 524.710938 C 548.542969 524.71875 551.539062 524.285156 554.46875 523.410156 C 557.402344 522.53125 560.148438 521.253906 562.703125 519.570312 L 451.707031 413.960938 Z M 406 457.460938 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#E53535",
    d: "M 240.8125 300.269531 C 237.835938 304.335938 235.929688 308.851562 235.097656 313.816406 L 235.097656 498.105469 C 235.929688 503.074219 237.835938 507.589844 240.8125 511.652344 L 351.890625 405.960938 Z M 240.8125 300.269531 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#E53535",
    d: "M 360.296875 397.964844 L 406 441.546875 L 562.703125 292.351562 C 560.148438 290.667969 557.402344 289.390625 554.46875 288.515625 C 551.539062 287.640625 548.542969 287.203125 545.480469 287.210938 L 266.519531 287.210938 C 263.460938 287.203125 260.464844 287.640625 257.53125 288.515625 C 254.601562 289.390625 251.855469 290.667969 249.300781 292.351562 Z M 360.296875 397.964844 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgC6);
export default __webpack_public_path__ + "static/media/c6.c3f412a56d8ec80ea6b5289aaa8df1b9.svg";
export { ForwardRef as ReactComponent };